<template>
  <h2 class="context-menu-title" :class="classModifier">
    <span class="prepend">
      <slot name="prepend"></slot>
    </span>
    <span class="text">
      <slot>{{ text }}</slot>
    </span>
    <span class="append">
      <slot name="append"></slot>
    </span>
  </h2>
</template>

<script setup>
import { computed, useSlots } from "vue";
defineProps({
  text: {
    type: String,
    default: "Title",
  },
});

const slots = useSlots();

const hasPrepend = computed(() => slots.prepend !== undefined);
const hasAppend = computed(() => slots.append !== undefined);

const classModifier = computed(() => ({
  "--offset-mode": hasPrepend.value || hasAppend.value,
}));
</script>

<style lang="scss" scoped>
.context-menu-title {
  --sp-comp-button-small-height: 32px;
  display: grid;
  grid-template-columns: 1fr;
  height: var(--sp-spacing-12);
  align-items: center;
  padding-inline: var(--sp-spacing-4);
  margin-block: 0;
  font-size: var(--sidebar-header-title-font-size, 1rem);
  font-weight: var(--sidebar-header-title-font-weight, 600);
  border-bottom: 1px solid var(--sidebar-header-title-border-color, rgba(0, 0, 0, 0.1));

  &.--offset-mode {
    --slot-col-width: var(--sp-spacing-8);
    grid-template-columns: var(--slot-col-width) 1fr var(--slot-col-width);
  }

  .append,
  .prepend {
    display: flex;
  }

  // Offset for Icon slots
  .prepend {
    margin-left: calc(var(--sp-spacing-2) * -1);
  }

  .append {
    margin-right: calc(var(--sp-spacing-2) * -1);
  }
}

.text {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}
</style>
